import React from 'react';
import styles from './styles.module.scss';
import Modal from 'src/Components/Modal';
import Button from '../../Components/Button';
import icClose from 'assets/svg/ic_close_2.svg';
import icSuccess from 'assets/img/ic_success.png';

const TransactionSuccessModal = ({
  onClose
}) => {
  return /*#__PURE__*/React.createElement(Modal, null, /*#__PURE__*/React.createElement("div", {
    className: styles.modal
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.header
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.label
  }), /*#__PURE__*/React.createElement("button", {
    className: styles.close,
    onClick: onClose
  }, /*#__PURE__*/React.createElement("img", {
    src: icClose
  }))), /*#__PURE__*/React.createElement("div", {
    className: styles.detailContainer
  }, /*#__PURE__*/React.createElement("img", {
    src: icSuccess,
    className: styles.icon
  }), /*#__PURE__*/React.createElement("span", {
    className: styles.title
  }, "Your request will be handled soon!"), /*#__PURE__*/React.createElement("span", {
    className: styles.description
  }, "You can view your activity from the History section of the Profile page after the process has finished."), /*#__PURE__*/React.createElement("div", {
    className: styles.buttonGroup
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: onClose,
    title: "I understand"
  })))));
};

export default TransactionSuccessModal;